import { ProcessPaymentResult } from './ProcessPaymentResult'

export const hasTrial = (result: ProcessPaymentResult) => {
  let trial = false
  const item = result.data?.checkout?.transaction?.planIds?.find(x => x.toUpperCase().endsWith('TRIAL-34-95'))
  if (item) {
    trial = true
  }
  return trial
}